<template>
  <div>
    <van-nav-bar
      title="高校开学防疫攻略"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div>
      <div class="videoCon">
        <div class="video">
          <iframe
            style="width:100%;height:100%;"
            src="https://2d.hep.com.cn/1918571/5"
            frameborder="0"
            scrolling="no"
            id="bdIframe"
          ></iframe>
        </div>
      </div>
    </div>

    <WxShare></WxShare>
  </div>
</template>

<script>
import WxShare from "../components/WxShare";
export default {
  components: {
    WxShare
  },
  data() {
    return {
      activeNames: "1"
    };
  },

  mounted() {
    const oIframe = document.getElementById("bdIframe");
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = Number(deviceWidth) - 0 + "px";
    oIframe.style.height = Number(deviceHeight) - 50 + "px";
  },

  methods: {
    onClickLeft() {
      this.$router.push({ path: "/menu" });
    }
  }
};
</script>

<style scoped>
.videoCon {
  text-align: center;
  height: auto;
}
</style>
